'use client';

import { useEffect, useState } from 'react';
import { useRouter, usePathname } from 'next/navigation';
import { useDispatch } from 'react-redux';
import { removeAccessToken } from '@/lib/auth';
import { api } from '@/redux/apiSlices/api';
import { setBearerToken } from '@/redux/slices/authSlice';
import { setOrderDetails } from '@/redux/slices/orderSlice';
import { setUserCart } from '@/redux/slices/userCartSlice';
import { setUserDetails } from '@/redux/slices/userSlice';

const protectedRoutes = [
  '/my-account',
  '/my-address',
  '/my-order',
  '/list',
  '/checkout',
  '/success-order',
];

const useHandleLogout = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const pathname = usePathname();
  const [pendingLogout, setPendingLogout] = useState(false);

  useEffect(() => {
    if (pendingLogout && pathname === '/') {
      performLogout();
      setPendingLogout(false);
    }
  }, [pathname, pendingLogout]);

  const performLogout = () => {
    removeAccessToken();
    dispatch(setBearerToken({ token: null, isLogin: false }));
    dispatch(setUserCart({}));
    dispatch(setUserDetails({}));
    dispatch(setOrderDetails({}));
    dispatch(api.util.resetApiState());
  };

  return () => {
    if (protectedRoutes.some((route) => pathname.startsWith(route))) {
      setPendingLogout(true);
      router.push('/');
    } else {
      performLogout();
    }
  };
};

export default useHandleLogout;
